import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { Box } from '@mui/material';

const ImagesCarouselSection = ({ spaceData }) => {
  const imagesArray = (() => {
    try {
      const parsed =
        spaceData?.url_img && spaceData?.url_img !== null
          ? JSON.parse(spaceData?.url_img)
          : JSON.parse(spaceData?.main_image);

      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceData?.main_image].filter(Boolean);
    } catch {
      return [spaceData?.main_image].filter(Boolean);
    }
  })();

  return (
    <FlexContainer className="width100 bgGradientReviewBlue180 borderrad14 pad20 overflow-hidden">
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          width: '100%',
        }}
      >
        {imagesArray.map((img, index) => (
          <Box
            key={index}
            component="img"
            src={img}
            alt={`space-image-${index}`}
            sx={{
              minWidth: '180px',
              width: 'calc(25% - 12px)',
              height: '260px',
              objectFit: 'cover',
              borderRadius: '10px',
              flexShrink: 0,
            }}
          />
        ))}
      </Box>
    </FlexContainer>
  );
};

export default ImagesCarouselSection;
